import { Link } from "react-router-dom";

const PolicesLinks = () => {
  return (
    <div className="footer-section footer-links">
      <div className="link-wrapper">
        <p className="footer-heading">Policies</p>
        <Link className="link" to="/terms-and-conditions">
          Terms and Conditions
        </Link>
        <Link className="link" to="/privacy-policy">
          Privacy Policy
        </Link>
        <Link className="link" to="/cookie-policy">
          Cookie Policy
        </Link>
        <Link className="link" to="/platform-rules-safety">
          Platform Rules & Safety
        </Link>
      </div>
    </div>
  );
};

export default PolicesLinks;
